<template>
	<div class="row race-schedule-date">
		<div class="small-12 columns white">
			<span class="date">{{ formattedDate }}</span>
			<a href="#" v-if="daysInRacing.length > 0" @click.prevent="toggleDayInRacing"
			   class="small serif italic lowercase">Did you know...</a>
			<div class="day-in-racing" :class="{ 'visible': daysInRacingVisible }"
			     v-if="daysInRacing.length > 0" v-touch:swipeleft="goToNextDayInRacing" v-touch:swiperight="goToPreviousDayInRacing" @next="goToNextDayInRacing" @previous="goToPreviousDayInRacing">
				<div class="days-container">
					<day-in-racing :active="activeDayInRacing == $index"
					               :next="nextDayInRacing == $index"
					               :previous="previousDayInRacing == $index"
					               :day="day"
					               v-for="day in daysInRacing"></day-in-racing>
				</div>
				<div class="controls text-center" v-if="daysInRacing.length > 1">
					<a href="#" @click.prevent="goToPreviousDayInRacing">
						<img v-icon.literal="left-arrow.svg" class="svg"
						     alt="Previous"/>
					</a>
					<span class="indicator">{{ activeDayInRacing + 1 }} / {{ daysInRacing.length }}</span>
					<a href="#" @click.prevent="goToNextDayInRacing">
						<img v-icon.literal="left-arrow.svg" class="arrow-flipped svg" alt="Next"/>
					</a>
				</div>
				<a class="close icon-button" href="#" @click.prevent="toggleDayInRacing">
					<img v-icon.literal="close.svg" alt="Close" class="svg"/>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import DayInRacing from './DayInRacing.vue'
	import DaysInRacing from './../store/DaysInRacing'
  import Moment from 'moment'
	export default {
		components: { DayInRacing },
		props: ['date'],
		data () {
			return {
				daysInRacing: [],
				activeDayInRacing: 0,
				daysInRacingVisible: false
			};
		},
		asyncData () {

			var self = this;

			// Get the days in racing for the current date.
			return DaysInRacing.getInstance().fetch({
				parameters: {
					'field_date.con': self.date.format('-MM-DD')
				}
			}).then(function (daysInRacing) {
				return {
					activeDayInRacing: 0,
					daysInRacing: daysInRacing
				};
			}, function () {
				return {
					daysInRacing: []
				}
			});

		},
		computed: {
			formattedDate() {
			  return Moment.utc(this.date).format('M.DD');
			},
			nextDayInRacing() {
				if (this.daysInRacing.length - 1 > this.activeDayInRacing) {
					return this.activeDayInRacing + 1;
				} else {
					return 0;
				}
			},
			previousDayInRacing() {
				if (this.activeDayInRacing === 0) {
					return this.daysInRacing.length - 1;
				} else {
					return this.activeDayInRacing - 1;
				}
			}
		},
		methods: {
			toggleDayInRacing: function (e) {
				this.daysInRacingVisible = !this.daysInRacingVisible;
			},
			goToPreviousDayInRacing: function (e) {
				this.activeDayInRacing = this.previousDayInRacing;
			},
			goToNextDayInRacing: function (e) {
				this.activeDayInRacing = this.nextDayInRacing;
			},
			updateSVG: function () {
				window.jQuery(document).trigger('reSVG');
			}
		},
		watch: {
			daysInRacing: 'updateSVG',
			date: 'reloadAsyncData'
		}
	}
</script>



/** WEBPACK FOOTER **
 ** RaceListDateLabel.vue?1a1b6e10
 **/